import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { IPatchTunningRequest, IPostTunningRequest } from './apiTunning.models';
import { API_TUNNING_URL } from './apiTunningUrl.constants';
import { UtilsService } from '../../services/utils/utils.service';
import { EnvironmentService } from '../../services/enviroment/environment.service';
import { SessionStorageService } from '../../services/session-storage/session-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ApiTunningService extends ApiService {
  private hasAuthBasic: boolean;
  private connectionId?: string;
  private attendantId?: string;
  private tunningId?: number;
  private tunningSaved = false;
  constructor(
    utils: UtilsService,
    private readonly apiService: ApiService,
    private readonly environmentService: EnvironmentService,
    private readonly http: HttpClient,
    private readonly sessionStorageSrv: SessionStorageService
  ) {
    super(utils);
    this.hasAuthBasic = !!environmentService.data.authorizationBasic;
  }
  get _connectionId(): string {
    const id = this.sessionStorageSrv.get('connectionId');
    return id || this.connectionId;
  }
  set _connectionId(connectionId: string) {
    const id = this.sessionStorageSrv.get('connectionId');
    !id && this.sessionStorageSrv.set('connectionId', connectionId);
    this.connectionId = id || connectionId;
  }
  get _attendantId(): string {
    return this.attendantId || '';
  }
  set _attendantId(attendantId: string) {
    this.attendantId = attendantId;
  }
  get _tunningId(): number {
    const id = this.sessionStorageSrv.get('tunningId');
    return id || this.tunningId;
  }
  set _tunningId(tunningId: number) {
    this.sessionStorageSrv.set('tunningId', tunningId);
    this.tunningId = tunningId;
  }
  get _tunningSaved(): boolean {
    const savedFlag = this.sessionStorageSrv.get('tunningSaved');
    return savedFlag || this.tunningSaved;
  }
  set _tunningSaved(tunningSaved: boolean) {
    this.sessionStorageSrv.set('tunningSaved', tunningSaved);
    this.tunningSaved = tunningSaved;
  }

  postTunnings(body: IPostTunningRequest) {
    const apiInstance = this.apiService.getApiInstance(
      API_TUNNING_URL.POST_TUNNING
    );

    const url = this.getApiUrl(
      this.environmentService.data.apiUrl,
      apiInstance
    );
    const authorizationHeader = this.getAuthorizationHeader(
      apiInstance.security.authorizationBasic
    );
    body.attendant = this._attendantId;
    body.connectionId = null;
    return this.hasAuthBasic
      ? this.http.post(url, body, authorizationHeader)
      : this.http.post(url, body);
  }

  patchTunnings(body: IPatchTunningRequest) {
    const apiInstance = this.apiService.getApiInstance(
      API_TUNNING_URL.PATCH_TUNNING
    );
    apiInstance.params['id'].value = this._tunningId;
    body.id = this._tunningId;
    apiInstance.params['connectionId'].value = this._connectionId;

    const url = this.getApiUrl(
      this.environmentService.data.apiUrl,
      apiInstance
    );
    const authorizationHeader = this.getAuthorizationHeader(
      apiInstance.security.authorizationBasic
    );
    return this.hasAuthBasic
      ? this.http.patch(url, body, authorizationHeader)
      : this.http.patch(url, body);
  }

  private getAuthorizationHeader(authorizationBasicCode: string): any {
    return { headers: { authorization: authorizationBasicCode } };
  }
}
